(function(angular){
	'use strict';
	
	var reitElementCardObject = {
		templateUrl: [
			'$attrs',
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			layout: '@',
			reitElement: '<'
		},
		controller: [
			'$rootScope',
			ReitElementCardFunction
		],
		controllerAs: 'reitElementCard'
	};
	
	angular
		.module('reitElementListingModule')
		.component('reitElementCard', reitElementCardObject);
	
	function templateUrlFunction($attrs, STATIC_BASE_PATH){
		if($attrs.layout === 'horizontal') {
			return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-card-horizontal.html';
		} else {
			return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-card.html';
		}
	}
	
	function ReitElementCardFunction(
		$rootScope
	) {
		var reitElementCard = this;

		reitElementCard.handleClick = function() {
			$rootScope.ModalFactory.openReitElement({
				reitElement: reitElementCard.reitElement
			});
		};
	}
})(window.angular);